module.exports = __webpack_public_path__ + "static/media/notes.8e40b2fc.svg";